import script from "./LicenseContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseContent.vue?vue&type=script&setup=true&lang=js"

import "./LicenseContent.vue?vue&type=style&index=0&id=68e08cae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e08cae"]])

export default __exports__